import * as React from "react";
import { ApiError } from "@eduviaos/shared";
import { useEnabledModules } from "@/hooks/useEnabledModules";
import { clientFacingText, roleLabelFor } from "@/lib/verticalProfile";

/**
 * Words for the people being paid. A study centre says "Team" and
 * "Team member" (Iron Rule #20); school and coaching keep "Staff".
 */
export interface TeamWords {
  team: string;
  member: string;
  members: string;
  say: (text: string) => string;
}

export function useTeamWords(): TeamWords {
  const { vertical } = useEnabledModules();
  return React.useMemo(() => {
    const v = vertical ?? "school";
    return {
      team: v === "study_centre" ? "Team" : "Staff",
      member: roleLabelFor(v, "staff", "Staff member"),
      members: v === "study_centre" ? "Team members" : "Staff members",
      say: (text: string) => clientFacingText(v, text),
    };
  }, [vertical]);
}

export function errorMessage(
  err: unknown,
  fallback = "Something went wrong. Please retry.",
): string {
  if (err instanceof ApiError) return err.message || fallback;
  if (err instanceof Error) return err.message || fallback;
  return fallback;
}
